(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumReportGroupDeleteController',CompendiumReportGroupDeleteController);

    CompendiumReportGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompendiumReportGroup'];

    function CompendiumReportGroupDeleteController($uibModalInstance, entity, CompendiumReportGroup) {
        var vm = this;

        vm.compendiumReportGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CompendiumReportGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
